import {Component, Input, OnInit} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {AddressFestEnumLabels, Betriebstaette} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import { ActivatedRoute } from '@angular/router';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'common-ui-betriebstaette-special-form',
  templateUrl: './betriebstaette-special-form.component.html',
  styleUrls: ['./betriebstaette-special-form.component.scss']
})
export class BetriebstaetteSpecialFormComponent extends FormBaseComponent<Betriebstaette> implements OnInit {

  @Input()
  public betriebstaette: Betriebstaette;
  @Input()
  public stammdaten: Betriebstaette;
  public addressFestEnum = AddressFestEnumLabels;
  public inlandAddresseShown: boolean;
  public maxTelefonnummern = 1;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly currentRoute: ActivatedRoute,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  ngOnInit(): void {
    if (this.betriebstaette.stammdatenIndex !== undefined) {
      const stammdatenWithIndex = cloneDeep(
        this.currentRoute.snapshot.data.stammdaten.unternehmen.betriebstaetten[this.betriebstaette.stammdatenIndex]
      );
      this.stammdaten = stammdatenWithIndex.value;
    }
    this.data = this.betriebstaette;
    if (this.data.kommunikationsmittel?.telefonnummern && this.data.kommunikationsmittel?.telefonnummern.length > this.maxTelefonnummern) {
      this.data.kommunikationsmittel.telefonnummern = this.data.kommunikationsmittel.telefonnummern.slice(0, this.maxTelefonnummern);
    }
    super.ngOnInit();
  }

  public onAddressFestChanged(): void {
    if (!this.data.addressFest) {
      this.form.get('eigentum').setValue(null);
    }
    if (this.data.addressFest === AddressFestEnumLabels.NichtFest) {
      this.data.auslandsadresse = null;
    }
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      bezeichnung: [this.data.bezeichnung, [
        this.validatorService.required(),
        this.validatorService.maxLength(120)
      ]],
      addressFest: [this.data.addressFest, [
        this.validatorService.required()
      ]],
      eigentum: [this.data.eigentum]
    });
  }

}
